import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Jenkins\\workspace\\ITDCS\\JCEW.CAMP\\ITDCS_JCEW.CAMP_HappyWed\\src\\app\\[lang]\\parties\\[detail]\\page.tsx");
